<template>
  <BaseLoading v-if="isPoolStandingsLoading" />
  <div v-else-if="poolStandings.length">
    <ThePoolUserRow
      v-for="standings in poolStandings"
      :key="`pool-user-${standings.id}`"
      :position="standings.position"
      :score="standings.score"
      :predictions="standings.prediction"
      :avatar="standings.avatar.image_url"
      :name="standings.name"
      :is-my-position="standings.isMe"
    />
  </div>
  <BaseAlert
    v-else
    variant="light"
    is-center
  >
    {{ $t('you-are-not-a-member-of-any-clan') }}
  </BaseAlert>
</template>

<script>
import { mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import ThePoolUserRow from '@/pages/RoundDetail/Components/Molecules/ThePoolUserRow'
import BaseAlert from '@/components/Atoms/BaseAlert'
export default {
  name: 'RoundDetailHighlights',
  components: {
    BaseAlert,
    ThePoolUserRow,
    BaseLoading,
  },
  data() {
    return {
      roundId: this.$route.params.roundId,
    }
  },
  computed: {
    ...mapState({
      isPoolStandingsLoading: state => state['rounds/summer/poolStandings'].isPoolStandingsLoading,
    }),
    poolStandings() {
      return this.$store.getters['rounds/summer/poolStandings/getRoundPullStandings'](this.roundId)
    },
  },
  created() {
  },
}
</script>
